import card from "./components/card";
import swiperSlideshow from "./components/swiperSlideshow.js";
import accordion from "./components/accordion.js";
import accordionplus from "./components/accordion-plus.js";
import textanimations from "./components/text-animations.js";
import jpgcover from "./components/jpgcover.js";
import animatedDetails from "./components/animated-details.js";
import imgUpsize from "./components/img-upsize.js";
import imgCycle from "./components/img-cycle.js";
import peopleToggle from "./components/people-toggle.js";
import anchorNav from "./components/anchor-nav.js";
import chipsFilters from "./components/chips-filters.js";

class App {
	constructor(options) {
		this.defaults = {
			defaultK: false,
		};
		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = "App";
		this.init();
	}

	init() {
		this.headerFuncs();
		// this.initFunc();
		this.initCards();
		this.initSwiperSliders();
		this.initIcons();
		this.initAccordion();
		this.initAccordionPlus();
		this.initAnimatedDetails();
		this.initTextAnimations();
		this.initHero();
		// this.initTemp();
		this.initVideos();
		this.initReadMore();
		this.initSectionCapHeight();
		this.initHovBlocker();
		this.initImgUpsize();
		this.initPeopleToggle();
		this.initAnchorNav();
		this.initImgCycle();
		this.initCHIPSFilters();
		this.initSupportModal();
		this.initPageScroll();

		this.initAccessibilityUpdates();
	}

	headerFuncs() {
		const menuToggle = document.querySelector(".menu-toggle");
		if (menuToggle) {
			document.addEventListener("keydown", (e) => {
				if (e.key === "Escape") {
					document.body.classList.remove("menu-on");
					document.body.classList.remove("menu-altfont");
				}
			});
			menuToggle.addEventListener("click", () => {
				document.body.classList.toggle("menu-on");
				document.body.classList.remove("menu-altfont");

				if (document.body.classList.contains("menu-on")) {
					setTimeout(function () {
						document.body.classList.add("menu-altfont");
					}, 200);
					const navPanel = document.querySelector(".nav-panel");
					const header = document.querySelector(".eyebeam-header");
					const focusableEls = navPanel.querySelectorAll(
						"a, button, input, textarea, select"
					);
					const firstFocusableEl = focusableEls[0];
					const lastFocusableEl =
						focusableEls[focusableEls.length - 1];

					if (navPanel) {
						// firstFocusableEl.focus();
						navPanel.addEventListener("keydown", (e) => {
							let isTabPressed =
								e.key === "Tab" || e.keyCode === 9;

							if (!isTabPressed) {
								return;
							}

							if (e.shiftKey) {
								if (
									document.activeElement === firstFocusableEl
								) {
									lastFocusableEl.focus();
									e.preventDefault();
								}
							} else {
								if (
									document.activeElement === lastFocusableEl
								) {
									firstFocusableEl.focus();
									e.preventDefault();
								}
							}
						});
					}
				} else {
				}
			});
		}

		const menuToggleMobile = document.querySelector(".mobile-menu-toggle");
		if (menuToggleMobile) {
			menuToggleMobile.addEventListener("click", () => {
				document.body.classList.toggle("menu-on");
			});
		}

		const header = document.querySelector(".eyebeam-header");
		if (header) {
			window.addEventListener("scroll", () => {
				if (window.scrollY >= 20) {
					header.classList.add("scrolled");
				} else {
					header.classList.remove("scrolled");
				}
			});
		}

		const formOptIn = document.querySelector(".form-optin");
		if (formOptIn) {
			formOptIn.addEventListener("click", (e) => {
				e.preventDefault();
				document
					.querySelector(".newsletter-form")
					.classList.add("show");
			});
		}

		/*
		const newsletterSignup = document.querySelector(
			".newsletter-form.inline-form-submit"
		);
		if (newsletterSignup) {
			newsletterSignup.addEventListener("submit", (e) => {
				e.preventDefault();

				const form = document.querySelector("#subscribe");
				const args = new FormData(form);
				const url = form.getAttribute("action");
				form.classList.add("loading");
				form.classList.remove("success");
				form.classList.remove("error");
				fetch(url, {
					method: "POST",
					body: args,
				})
					.then((rsp) => rsp.json())
					.then((rsp) => {
						console.log(rsp);
						form.classList.remove("loading");
						form.classList.remove("success");
						form.classList.remove("error");
						if (rsp.ok) {
							form.classList.add("success");
						} else {
							form.classList.add("error");
						}
					})
					.catch((err) => {
						console.log(err);
						form.classList.remove("loading");
						form.classList.remove("success");
						form.classList.add("error");
					});
			});
		}
		*/

		const donateTypes = document.querySelectorAll(".donate-types label");
		if (donateTypes) {
			donateTypes.forEach((el) => {
				el.addEventListener("click", () => {
					const input = document.querySelector(
						`#${el.getAttribute("for")}`
					);
					if (input.checked) {
						setTimeout(function () {
							input.checked = false;
						}, 100);
					}
				});
			});
		}

		const filtersToggle = document.querySelector(".toggleFilters");
		if (filtersToggle) {
			filtersToggle.addEventListener("click", () => {
				document
					.querySelectorAll(".landing-filter-wrap, .toggleFilters")
					.forEach((el) => {
						el.classList.toggle("filters-on");
					});
			});
		}

		// const tabbedHtmlInputs = document.querySelectorAll(
		// 	".section-tabbed_html input[type='radio']"
		// );
		// if (tabbedHtmlInputs) {
		// 	tabbedHtmlInputs.forEach((el) => {
		// 		el.addEventListener("change", () => {
		// 			const id = el.getAttribute("id");
		// 			console.log(id);

		// 			const htmlTargets =
		// 				document.querySelectorAll(`.HTML-target`);
		// 			if (htmlTargets) {
		// 				htmlTargets.forEach((el) => {
		// 					el.innerHTML = "";
		// 				});
		// 			}

		// 			const newTarget = document.querySelector(
		// 				".donatetarget_" + id
		// 			);
		// 			if (newTarget) {
		// 				const htmlWidget =
		// 					newTarget.querySelector(".HTML-contents").value;
		// 				if (newTarget) {
		// 					newTarget.querySelector(".HTML-target").innerHTML =
		// 						htmlWidget;
		// 				}
		// 				// get the value of the textarea htmlWidget
		// 				// const html = htmlWidget.querySelector("textarea").value;
		// 				console.log(htmlWidget);
		// 			} else {
		// 				console.log("no target");
		// 				console.log(".donatetarget_" + id);
		// 			}
		// 		});
		// 	});
		// }
	}

	initPageScroll() {
		const prefooter = document.querySelector(".component__prefooter");
		const nav = document.querySelector("nav.stick");
		if (prefooter && nav) {
			window.addEventListener("scroll", () => {
				const winHeight = window.innerHeight;
				const scrollCheckpoint =
					prefooter.getBoundingClientRect().top - winHeight;

				if (scrollCheckpoint <= 0) {
					nav.classList.add("footer-on");
				} else {
					nav.classList.remove("footer-on");
				}
			});
		}

		const navScrollable = document.querySelector(".nav-scrollable");
		if (navScrollable) {
			navScrollable.addEventListener("scroll", () => {
				if (navScrollable.scrollTop > 10) {
					document
						.querySelector(".site-name")
						.classList.add("mobile-menu-scrolled");
				} else {
					document
						.querySelector(".site-name")
						.classList.remove("mobile-menu-scrolled");
				}
			});
		}
	}

	initSwiperSliders() {
		const swiperEls = document.querySelectorAll(".swiper");
		if (swiperEls.length <= 0) {
			return;
		}
		swiperEls.forEach((el) => {
			const swiper = new swiperSlideshow({ $el: el });
		});
	}

	initAccordion() {
		const accordionEls = document.querySelectorAll(
			".component__accordion details"
		);
		if (accordionEls.length <= 0) {
			return;
		}
		accordionEls.forEach((el) => {
			const accordionEl = new accordion({ $el: el });
		});
	}

	initPeopleToggle() {
		const toggleEls = document.querySelectorAll(".grid-people");
		if (toggleEls.length <= 0) {
			return;
		}
		toggleEls.forEach((el) => {
			const peopleToggleEl = new peopleToggle({ $el: el });
		});
	}

	initAccordionPlus() {
		const accordionPlusEls = document.querySelectorAll(
			".component__tabbed details"
		);
		if (accordionPlusEls.length <= 0) {
			return;
		}
		accordionPlusEls.forEach((el) => {
			const accordionPlusEl = new accordionplus({ $el: el });
		});
	}

	initCHIPSFilters() {
		const chipsFilterEls = document.querySelectorAll(".landing-filters");
		if (chipsFilterEls.length <= 0) {
			return;
		}
		chipsFilterEls.forEach((el) => {
			const chipsFilterEl = new chipsFilters({ $el: el });
		});
	}

	initAnimatedDetails() {
		const aniDetailsEls = document.querySelectorAll(".animated-details");
		if (aniDetailsEls.length <= 0) {
			return;
		}
		aniDetailsEls.forEach((el) => {
			const aniDetail = new animatedDetails({ $el: el });
		});
	}

	initImgUpsize() {
		const upsizeImgs = document.querySelectorAll(".tinythumb + img");
		if (upsizeImgs.length <= 0) {
			return;
		}
		upsizeImgs.forEach((el) => {
			const upsizeImg = new imgUpsize({ $el: el });
		});
	}
	initImgCycle() {
		const imgCycleEls = document.querySelectorAll(".img-cycle");
		if (imgCycleEls.length <= 0) {
			return;
		}
		imgCycleEls.forEach((el) => {
			const imgCycleEl = new imgCycle({ $el: el });
		});
	}
	initAnchorNav() {
		const anchorNavEls = document.querySelectorAll("nav.stick");
		if (anchorNavEls.length <= 0) {
			return;
		}
		anchorNavEls.forEach((el) => {
			const anchorNavEl = new anchorNav({ $el: el });
		});
	}

	initTextAnimations() {
		const textAniEls = document.querySelectorAll(
			".component__page-title, .component__text > h2, .component__text_wrap > h2:not(.section-header) .word-wrap, .has-text-ani, .component-hero_theme .hero__text, section>h2.auto, section>h2.centered, h2.center, .rte h2"
		);
		//, .component-hero_interview .hero__text span
		if (textAniEls.length <= 0) {
			return;
		}
		textAniEls.forEach((el) => {
			const textAniEl = new textanimations({ $el: el, delayed: true });
		});
	}

	initCards() {
		const cardEls = document.querySelectorAll("[data-component='card']");
		if (cardEls.length <= 0) {
			return;
		}
		cardEls.forEach((el) => {
			const cardEl = new card({ $el: el });
		});
	}

	initIcons() {
		const iconArrowR = document.querySelectorAll(
			".icon-arrow-right, .component-accordion-plus button, .form-optin"
		);
		const iconArrowRightSVG = `<i class="icon-arrow-right_svg js-insert"><svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="16" cy="16" r="15.5" transform="rotate(-90 16 16)" stroke="#000"/><path d="M15.916 9 23 16l-7.084 7M9 16.012h13.595" stroke000fff" stroke-width="1.5"/></svg></i>`;
		if (iconArrowR && iconArrowR.length > 0) {
			iconArrowR.forEach((el) => {
				el.innerHTML += iconArrowRightSVG;
			});
		}

		const iconChangelog = document.querySelectorAll(".icon-changelog");
		const iconChangelogSVG = `<i class="icon-changelog_svg js-insert"><svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.63 14.609c0-.765.622-1.392 1.383-1.392a1.371 1.371 0 0 1 1.385 1.378c0 .779-.61 1.391-1.37 1.405a1.413 1.413 0 0 1-1.399-1.391ZM0 8.04c0-.764.61-1.39 1.384-1.39a1.371 1.371 0 0 1 1.384 1.377c0 .78-.609 1.391-1.37 1.405-.761 0-1.37-.626-1.384-1.391H0ZM13.232 8s-.014-.056-.014-.084c0-.765.609-1.391 1.37-1.405.775 0 1.398.612 1.398 1.377 0 0 .014.084.014.111 0 .766-.623 1.392-1.398 1.392a1.38 1.38 0 0 1-1.37-1.392ZM7.943 2.783a1.4 1.4 0 0 1-1.398-1.378C6.545.626 7.155 0 7.915 0a1.383 1.383 0 0 1 1.399 1.378c0 .765-.61 1.39-1.37 1.405Z" fill="#fff"/></svg></i>`;
		if (iconChangelog && iconChangelog.length > 0) {
			iconChangelog.forEach((el) => {
				el.innerHTML = iconChangelogSVG + el.innerHTML;
			});
		}

		const iconAccordionPlus = document.querySelectorAll(
			".component__tabbed details"
		);
		const iconAccordionPlusSVG = `<i class="icon-tabplus js-insert"><svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="16" cy="16" r="15.5" stroke="#E0E0E0"/><path d="M16 8v16m-8-8h16" stroke="#6E7D32" stroke-width="1.5"/></svg></i>`;
		if (iconAccordionPlus && iconAccordionPlus.length > 0) {
			iconAccordionPlus.forEach((el) => {
				const summaryEl = el.querySelector("summary");
				summaryEl.innerHTML =
					summaryEl.innerHTML + iconAccordionPlusSVG;
			});
		}

		const iconNE = document.querySelectorAll(
			".link-ext, .nav-openeyebeam, [href*='://open.eyebeam.org']"
		);
		const iconNESVG = `<i class="icon-ne_svg js-insert"><svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M15 14.177V1H1.846M1 15 14.613 1.365" stroke="#F7F7F7"/></svg></i>`;
		if (iconNE && iconNE.length > 0) {
			iconNE.forEach((el) => {
				el.innerHTML = el.innerHTML + iconNESVG;
			});
		}

		const iconFeed = document.querySelectorAll(".nav-feed");
		const iconFeedSVG = `<i class="icon-feed_svg js-insert"><svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 24"><path d="M.876 12.841a1.138 1.138 0 0 1-.332-.84c0-.34.11-.619.332-.84.22-.221.5-.332.84-.332.34 0 .619.11.84.332.221.221.332.5.332.84 0 .34-.11.62-.332.84-.221.222-.5.333-.84.333-.34 0-.62-.111-.84-.332Zm9.889 9.89c1.472-1.478 2.577-3.148 3.315-5.01A15.405 15.405 0 0 0 15.192 12c0-1.942-.37-3.849-1.112-5.719-.738-1.863-1.843-3.533-3.316-5.01l.55-.55c1.552 1.557 2.711 3.313 3.478 5.267a16.333 16.333 0 0 1 1.154 6.012c0 2.046-.385 4.05-1.155 6.013-.767 1.954-1.926 3.71-3.477 5.265l-.55-.549Zm-4.507-4.507c1.765-1.773 2.655-3.854 2.667-6.242.013-2.387-.864-4.468-2.63-6.241l.55-.55c.944.95 1.648 2.01 2.111 3.182a9.68 9.68 0 0 1 .696 3.611 9.626 9.626 0 0 1-.714 3.605c-.471 1.168-1.181 2.23-2.13 3.184l-.55-.55Z" fill="#F7F7F7" stroke="#F7F7F7" stroke-width=".05"/></svg></i>`;
		if (iconFeed && iconFeed.length > 0) {
			iconFeed.forEach((el) => {
				el.innerHTML = el.innerHTML + iconFeedSVG;
			});
		}

		const iconEXT = document.querySelectorAll(".add-icon__ext");
		const iconEXTSVG = `<i class="icon-ext_svg js-insert"><svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><circle cx="16" cy="16" r="15.5" transform="rotate(-90 16 16)" stroke="#E0E0E0"/><path d="m10.99 11.11 9.96-.06-.06 9.96m-9.831-.052 9.613-9.613" stroke="#262626" stroke-width="1.5"/></svg></i>`;
		if (iconEXT && iconEXT.length > 0) {
			iconEXT.forEach((el) => {
				el.innerHTML = iconEXTSVG + el.innerHTML;
			});
		}

		// const iconChangelog = document.querySelectorAll(".icon-changelog");
		// const iconChangelogSVG = `<i class="icon-changelog_svg js-insert"><svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.63 14.609c0-.765.622-1.392 1.383-1.392a1.371 1.371 0 0 1 1.385 1.378c0 .779-.61 1.391-1.37 1.405a1.413 1.413 0 0 1-1.399-1.391ZM0 8.04c0-.764.61-1.39 1.384-1.39a1.371 1.371 0 0 1 1.384 1.377c0 .78-.609 1.391-1.37 1.405-.761 0-1.37-.626-1.384-1.391H0ZM13.232 8s-.014-.056-.014-.084c0-.765.609-1.391 1.37-1.405.775 0 1.398.612 1.398 1.377 0 0 .014.084.014.111 0 .766-.623 1.392-1.398 1.392a1.38 1.38 0 0 1-1.37-1.392ZM7.943 2.783a1.4 1.4 0 0 1-1.398-1.378C6.545.626 7.155 0 7.915 0a1.383 1.383 0 0 1 1.399 1.378c0 .765-.61 1.39-1.37 1.405Z" fill="#fff"/></svg></i>`;
		// if (iconChangelog && iconChangelog.length > 0) {
		// 	iconChangelog.forEach((el) => {
		// 		el.innerHTML = iconChangelogSVG + el.innerHTML;
		// 	});
		// }
	}

	initVideos() {
		const jpgCoverEls = document.querySelectorAll(".jpg-cover");
		if (jpgCoverEls && jpgCoverEls.length > 0) {
			jpgCoverEls.forEach((el) => {
				const jpgCoverEl = new jpgcover({ $el: el });
			});
		}

		const pauseBtns = document.querySelectorAll(".button-pause");
		if (pauseBtns && pauseBtns.length > 0) {
			pauseBtns.forEach((el) => {
				el.addEventListener("click", () => {
					const scopeEl = el;
					scopeEl
						.closest(".videobg-wrap")
						.classList.add("vid-paused");
					const videoEl = scopeEl
						.closest(".videobg-wrap")
						.querySelector("iframe");
					videoEl.contentWindow.postMessage(
						'{"method":"pause"}',
						"https://player.vimeo.com"
					);
				});
			});
		}

		const playBtns = document.querySelectorAll(".button-play");
		if (playBtns && playBtns.length > 0) {
			playBtns.forEach((el) => {
				el.addEventListener("click", () => {
					const scopeEl = el;
					scopeEl
						.closest(".videobg-wrap")
						.classList.remove("vid-paused");
					const videoEl = scopeEl
						.closest(".videobg-wrap")
						.querySelector("iframe");
					videoEl.contentWindow.postMessage(
						'{"method":"play"}',
						"https://player.vimeo.com"
					);
				});
			});
		}

		const infoBtns = document.querySelectorAll(".button-info-wrap button");
		if (infoBtns && infoBtns.length > 0) {
			infoBtns.forEach((el) => {
				el.addEventListener("click", () => {
					const scopeEl = el;
					scopeEl
						.closest(".videobg-wrap")
						.classList.toggle("vid-info-on");
				});
			});
		}
	}

	initAccessibilityUpdates() {
		const images = document.querySelectorAll("img");
		if (images && images.length > 0) {
			images.forEach((el) => {
				const scopeEl = el;
				if (
					scopeEl.hasAttribute("alt") &&
					!scopeEl.hasAttribute("title")
				) {
					scopeEl.setAttribute("title", scopeEl.getAttribute("alt"));
				}
			});
		}
	}

	initHero() {
		const heroThemes = document.querySelectorAll(".component-hero_theme");
		if (heroThemes && heroThemes.length > 0) {
			heroThemes.forEach((el) => {
				const scopeEl = el;
				scopeEl
					.querySelector("button.hero-img-detail-toggle")
					.addEventListener("click", () => {
						// if .component-hero_theme does not have no-ani class, add it
						if (!scopeEl.classList.contains("no-ani")) {
							scopeEl.classList.add("no-ani");
						}
						scopeEl.classList.toggle("details-on");
					});
			});
		}
	}
	initReadMore() {
		const readMores = document.querySelectorAll("button.readmore");
		if (readMores && readMores.length > 0) {
			readMores.forEach((el) => {
				const scopeEl = el;
				scopeEl.addEventListener("click", () => {
					// add a class on the closest parent with class .readmore-container
					scopeEl
						.closest(".component__text")
						.classList.toggle("readmore-on");
				});
			});
		}
	}
	initSectionCapHeight() {
		const capHSections = document.querySelectorAll(".section-cap-height");
		if (capHSections && capHSections.length > 0) {
			capHSections.forEach((el) => {
				const scopeEl = el;

				const showFullBtn = document.createElement("button");
				showFullBtn.classList.add("show-full");
				showFullBtn.innerHTML = `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="16" cy="16" r="15.5" stroke="#E0E0E0"/><path d="M16 8v16m-8-8h16" class="stroke-ui" stroke-width="1.5"/></svg>
				<span class="visuallyhidden">Show full text</span>`;
				// scopeEl.appendChild(showFullBtn);
				//prepend the button
				scopeEl.insertBefore(showFullBtn, scopeEl.firstChild);
				showFullBtn.addEventListener("click", () => {
					scopeEl.classList.toggle("showing-full");
				});
			});
		}

		const readMoreEls = document.querySelectorAll(".readmore-content");
		if (readMoreEls && readMoreEls.length > 0) {
			readMoreEls.forEach((el) => {
				const scopeEl = el.parentElement;
				scopeEl.classList.add("readmore-container-js");

				// scopeEl.addEventListener("click", () => {
				// 	if (!scopeEl.classList.contains("showing-full")) {
				// 		scopeEl.classList.add("showing-full");
				// 	}
				// });

				const showFullBtn = document.createElement("button");
				showFullBtn.classList.add("show-full");
				showFullBtn.innerHTML = `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="16" cy="16" r="15.5" stroke="#E0E0E0"/><path d="M16 8v16m-8-8h16" class="stroke-ui" stroke-width="1.5"/></svg>
				<span class="visuallyhidden">Show full text</span>`;
				scopeEl.appendChild(showFullBtn);
				//prepend the button
				// scopeEl.insertBefore(showFullBtn, scopeEl.firstChild);
				showFullBtn.addEventListener("click", () => {
					scopeEl.classList.add("showing-full");
				});
			});
		}
	}

	initHovBlocker() {
		const hovBlockers = document.querySelectorAll(".hovn,.menu-toggle");
		if (hovBlockers && hovBlockers.length > 0) {
			hovBlockers.forEach((el) => {
				const scopeEl = el;
				scopeEl.addEventListener("click", () => {
					scopeEl.classList.add("hov-disable");
				});
				scopeEl.addEventListener("mouseleave", () => {
					scopeEl.classList.remove("hov-disable");
				});
			});
		}
	}

	initSupportModal() {
		const modalBg = document.querySelectorAll(".modal-bg, .modal-close");
		if (modalBg) {
			modalBg.forEach((elClose) => {
				elClose.addEventListener("click", () => {
					document.body.classList.remove("modal-gl-on");
				});
			});
		}

		const glModal = document.querySelectorAll(
			".donate-types #gl_1_0, .donate-types #gl_1_1, .donate-types #gl_1_2, .donate-types #gl_2_0, .donate-types #gl_2_1, .donate-types #gl_2_2"
		);
		if (glModal) {
			glModal.forEach((el) => {
				const scopeEl = el;

				// TODO, this is quite hacky, but trying to get GiveLively functional, Rework this
				scopeEl.addEventListener("click", (e) => {
					e.preventDefault();
					let newText = "";
					if (scopeEl.id === "gl_1_0") {
						const embedHtml =
							document.querySelector(".embed-html.active");
						if (embedHtml) {
							embedHtml.classList.remove("active");
						}
						const targetEmbed = document.querySelector(".embed-gl");
						if (targetEmbed) {
							targetEmbed.classList.add("active");
						}
						const modalContent = document.querySelector(
							".donatetarget_donatetype1_0 .text"
						);
						if (modalContent) {
							newText = modalContent.innerHTML;
						}

						const donationInput = document.querySelector(
							".gl-widget__donation-input-field"
						);
						if (donationInput) {
							donationInput.value = 100;
						}
						const SecondFreqBtn = document.querySelectorAll(
							".gl-widget__frequency-selection-container button"
						);
						if (SecondFreqBtn && SecondFreqBtn.length > 1) {
							SecondFreqBtn[1].click();
						}
					} else if (scopeEl.id === "gl_1_1") {
						const embedHtml =
							document.querySelector(".embed-html.active");
						if (embedHtml) {
							embedHtml.classList.remove("active");
						}
						const targetEmbed =
							document.querySelector(".embed-crypto");
						if (targetEmbed) {
							targetEmbed.classList.add("active");
						}
						const modalContent = document.querySelector(
							".donatetarget_donatetype1_1 .text"
						);
						if (modalContent) {
							newText = modalContent.innerHTML;
						}
					} else if (scopeEl.id === "gl_1_2") {
						const embedHtml =
							document.querySelector(".embed-html.active");
						if (embedHtml) {
							embedHtml.classList.remove("active");
						}
						const targetEmbed =
							document.querySelector(".embed-stock");
						if (targetEmbed) {
							targetEmbed.classList.add("active");
						}
						const modalContent = document.querySelector(
							".donatetarget_donatetype1_2 .text"
						);
						if (modalContent) {
							newText = modalContent.innerHTML;
						}
					} else if (scopeEl.id === "gl_2_0") {
						const embedHtml =
							document.querySelector(".embed-html.active");
						if (embedHtml) {
							embedHtml.classList.remove("active");
						}
						const targetEmbed = document.querySelector(".embed-gl");
						if (targetEmbed) {
							targetEmbed.classList.add("active");
						}
						const modalContent = document.querySelector(
							".donatetarget_donatetype2_0 .text"
						);
						if (modalContent) {
							newText = modalContent.innerHTML;
						}
						const firstFreqBtn = document.querySelector(
							".gl-widget__frequency-selection-container button"
						);
						if (firstFreqBtn) {
							firstFreqBtn.click();
						}

						const donationInput = document.querySelector(
							".gl-widget__donation-input-field"
						);
						if (donationInput) {
							donationInput.value = 10;
						}
					} else if (scopeEl.id === "gl_2_1") {
						const embedHtml =
							document.querySelector(".embed-html.active");
						if (embedHtml) {
							embedHtml.classList.remove("active");
						}
						const targetEmbed = document.querySelector(".embed-gl");
						if (targetEmbed) {
							targetEmbed.classList.add("active");
						}
						const modalContent = document.querySelector(
							".donatetarget_donatetype2_1 .text"
						);
						if (modalContent) {
							newText = modalContent.innerHTML;
						}
						const firstFreqBtn = document.querySelector(
							".gl-widget__frequency-selection-container button"
						);
						if (firstFreqBtn) {
							firstFreqBtn.click();
						}

						const donationInput = document.querySelector(
							".gl-widget__donation-input-field"
						);
						if (donationInput) {
							donationInput.value = 25;
						}
					} else if (scopeEl.id === "gl_2_2") {
						const embedHtml =
							document.querySelector(".embed-html.active");
						if (embedHtml) {
							embedHtml.classList.remove("active");
						}
						const targetEmbed = document.querySelector(".embed-gl");
						if (targetEmbed) {
							targetEmbed.classList.add("active");
						}
						const modalContent = document.querySelector(
							".donatetarget_donatetype2_2 .text"
						);
						if (modalContent) {
							newText = modalContent.innerHTML;
						}
						const SecondFreqBtn = document.querySelectorAll(
							".gl-widget__frequency-selection-container button"
						);
						if (SecondFreqBtn && SecondFreqBtn.length > 1) {
							SecondFreqBtn[1].click();
						}

						const donationInput = document.querySelector(
							".gl-widget__donation-input-field"
						);
						if (donationInput) {
							donationInput.value = 1000;
						}
					}
					const modalText = document.querySelector(
						".modal-gl-wrap .modal-text"
					);
					if (modalText) {
						modalText.innerHTML = newText;
					}

					document.body.classList.add("modal-gl-on");
				});
			});
		}
	}
}

const app = new App();
